import { useTranslation } from "react-i18next";
import { Global } from "iconsax-react";
import { EmptyState } from "@/shared/components";
import type { LanguageRecord } from "../../types/personalSheet";
import ProfileDataRow from "../ProfileDataRow";

interface Props {
  records: LanguageRecord[];
}

export default function LanguagesSection({ records }: Props) {
  const { t } = useTranslation("EmployeePortal");

  if (records.length === 0) {
    return <EmptyState noDataText={t("personalSheet.empty.languages")} noDataHint={t("personalSheet.empty.languagesHint")} compact />;
  }

  return (
    <div className="flex flex-col gap-6">
      {records.map(function renderRecord(record, index) {
        return (
          <div key={record.id} className="flex flex-col">
            <p className="text-label-md content-base-primary mb-3">
              {t("personalSheet.recordNumber", { number: index + 1 })}
            </p>
            <ProfileDataRow icon={Global} label={t("personalSheet.fields.language")} value={record.language} />
            <ProfileDataRow
              icon={Global}
              label={t("personalSheet.fields.proficiencyLevel")}
              value={t(`personalSheet.proficiencyLevels.${record.proficiency_level}`, {
                defaultValue: record.proficiency_level,
              })}
            />
          </div>
        );
      })}
    </div>
  );
}
